export default __webpack_public_path__ + "static/media/sendMessageIcon.bce8b390.svg";